export default __webpack_public_path__ + "static/media/checked.87611f97.svg";